var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { D2CTempDiscountDto } from '../../../classes/d2c-pre-reservation-discount/response/d2c-temp-discount.dto';
import { InsuranceForD2CDto } from '../../../classes/insurance';
import { VehicleModelAudioDto } from './vehicle-model-audio.dto';
import { VehicleModelInsuranceDto } from './vehicle-model-insurance.dto';
import { VehicleModelKeyOptionDto } from './vehicle-model-key-option.dto';
import { VehicleModelOptionDto } from './vehicle-model-option.dto';
export class VehicleModelWithInsuranceForD2CDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.companyId = initializer.companyId;
        this.name = initializer.name;
        this.title = initializer.title;
        this.type = initializer.type;
        this.fuel = initializer.fuel;
        this.seat = initializer.seat;
        this.transmission = initializer.transmission;
        this.drivingSystem = initializer.drivingSystem;
        this.driverAge = initializer.driverAge;
        this.driverExperience = initializer.driverExperience;
        this.keyOption = initializer.keyOption;
        this.modelOption = initializer.modelOption;
        this.audio = initializer.audio;
        this.availableWithInsuranceOption1 =
            initializer.availableWithInsuranceOption1;
        this.availableWithInsuranceOption2 =
            initializer.availableWithInsuranceOption2;
        this.totalCount = initializer.totalCount;
        this.availableCount = initializer.availableCount;
        this.minModelYear = initializer.minModelYear;
        this.maxModelYear = initializer.maxModelYear;
        this.imageUrls = initializer.imageUrls;
        this.referencePrice = initializer.referencePrice;
        this.branchNames = initializer.branchNames;
        this.insurance1 = initializer.insurance1;
        this.insurance2 = initializer.insurance2;
        this.insurance = initializer.insurance;
        this.tempDiscounts = initializer.tempDiscounts;
    }
}
__decorate([
    Type(() => VehicleModelKeyOptionDto),
    __metadata("design:type", VehicleModelKeyOptionDto)
], VehicleModelWithInsuranceForD2CDto.prototype, "keyOption", void 0);
__decorate([
    Type(() => VehicleModelOptionDto),
    __metadata("design:type", VehicleModelOptionDto)
], VehicleModelWithInsuranceForD2CDto.prototype, "modelOption", void 0);
__decorate([
    Type(() => VehicleModelAudioDto),
    __metadata("design:type", VehicleModelAudioDto)
], VehicleModelWithInsuranceForD2CDto.prototype, "audio", void 0);
__decorate([
    Type(() => VehicleModelInsuranceDto),
    __metadata("design:type", Object)
], VehicleModelWithInsuranceForD2CDto.prototype, "insurance1", void 0);
__decorate([
    Type(() => VehicleModelInsuranceDto),
    __metadata("design:type", Object)
], VehicleModelWithInsuranceForD2CDto.prototype, "insurance2", void 0);
__decorate([
    Type(() => InsuranceForD2CDto),
    __metadata("design:type", InsuranceForD2CDto)
], VehicleModelWithInsuranceForD2CDto.prototype, "insurance", void 0);
__decorate([
    Type(() => D2CTempDiscountDto),
    __metadata("design:type", Array)
], VehicleModelWithInsuranceForD2CDto.prototype, "tempDiscounts", void 0);
